/**
 * @file コンポーネント：フル動画ページスレッドポップアップ一覧ページ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { PopupThreadCard } from "~/src/components/pages/Video/Video/PopupThreadCard";
import { Button } from "~/src/components/uiparts/Button";
import { Pagination } from "~/src/components/uiparts/Pagination";
import { Paragraph } from "~/src/components/uiparts/Paragraph";
import { Select } from "~/src/components/uiparts/Select";

// スタイル読み込み
import {
    StyledButtonList,
    StyledButtonListItem,
    StyledContainer,
    StyledThreadList,
    StyledThreadListItem,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <>
            {props.isListThreadLoaded && (
                <StyledContainer ref={props.refContainer}>
                    {/* 成功、エラーメッセージ */}
                    {(props.messageList || props.errorMessageList) && (
                        <Paragraph
                            onColor="white"
                            paragraphType={
                                props.messageList ? "success" : "error"
                            }
                            text={
                                props.messageList
                                    ? props.messageList
                                    : props.errorMessageList
                            }
                        />
                    )}
                    {/* ボタンリスト */}
                    <StyledButtonList>
                        {/* スレッド新規作成ボタン */}
                        <StyledButtonListItem>
                            <Button
                                buttonType="main"
                                href="#"
                                icon={[
                                    <i
                                        className="fas fa-plus"
                                        key="icon-create"
                                    ></i>,
                                ]}
                                isFullHeight={true}
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.setCurrentPage("new");
                                    props.fnClearMessage();
                                }}
                                text={localized["Label.PostANewThread"]}
                            />
                        </StyledButtonListItem>
                        {/* ソートセレクトボタン */}
                        {props.listThread && (
                            <StyledButtonListItem
                                onClick={() => props.fnClearMessage()}
                            >
                                <Select
                                    list={[
                                        {
                                            text: localized[
                                                "Label.LatestReply"
                                            ],
                                            value: "replyDate",
                                        },
                                        {
                                            text: localized[
                                                "Label.LatestThread"
                                            ],
                                            value: "threadDate",
                                        },
                                        {
                                            text: localized[
                                                "Label.MostReplies"
                                            ],
                                            value: "replyCount",
                                        },
                                    ]}
                                    onChange={(e) => props.fnChangeSortType(e)}
                                    onColor="white"
                                />
                            </StyledButtonListItem>
                        )}
                    </StyledButtonList>
                    {props.listThread ? (
                        <>
                            {/* ページング */}
                            <Pagination
                                list={props.paginationlist}
                                onColor="white"
                            />
                            {/* スレッド一覧 */}
                            <StyledThreadList>
                                {props.listThread?.map((thread) => (
                                    <StyledThreadListItem
                                        key={"thread-" + thread.threadId}
                                    >
                                        <PopupThreadCard
                                            commentUserName={thread.userName}
                                            currentPage={props.currentPage}
                                            fnJump={props.fnJump}
                                            handleClickHeadline={() => {
                                                props.setCurrentPage("detail");
                                                props.setSelectedThread({
                                                    context: thread.context,
                                                    createdAt: thread.createdAt,
                                                    dateTimeAgo:
                                                        thread.dateTimeAgo,
                                                    isOwner: thread.isOwner,
                                                    isPublic: thread.isPublic,
                                                    replyCount:
                                                        thread.replyCount,
                                                    threadId: thread.threadId,
                                                    title: thread.title,
                                                    userName: thread.userName,
                                                });
                                                props.fnClearMessage();
                                            }}
                                            headline={thread.title}
                                            passedTime={thread.dateTimeAgo}
                                            replyCount={thread.replyCount}
                                        />
                                    </StyledThreadListItem>
                                ))}
                            </StyledThreadList>
                            {/* ページング */}
                            <Pagination
                                list={props.paginationlist}
                                onColor="white"
                            />
                        </>
                    ) : (
                        <>
                            {/* スレッドがない場合のメッセージ */}
                            <Paragraph
                                onColor="white"
                                text={localized["Label.NoThread"]}
                            />
                        </>
                    )}
                </StyledContainer>
            )}
        </>
    );
};
